import { Grid } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSMobileDataGridAdvanced, { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import { IsSmallScreen, MasterPages } from "../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../commonFunctions/PermissionDenied";
import { AllPermissions, getPermissions } from "../../commonFunctions/PermissionManger";

export const NotesList: React.FC<any> = React.memo((props) => {
       AllPermissions.getInstance();
       const { add,edit,remove, view} =AllPermissions.getNotesPermission;
    const navigate = useNavigate();
    const isMobile = IsSmallScreen();
    const source = {
        url: "notes/search",
        page: 1,
        pageSize: 10,
        filter: [
        ],
        sort: [],
    };

    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/note/edit/${row?.id}`)
        }

    };
    const columns: IColumns[] = [
        {
            header: "Notes",
            fieldName: "content",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];

    const mobColumns: IOrderColumns[] = [
        {
            header: "Notes",
            fieldName: "content",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Edit" : undefined].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),

        },
    ];

    const handleClick = () => {
        navigate('/note/create')
    }
    return (
        <>
            <Grid container spacing={2}>
                {view ? <Grid item xs={12}>
                    {!isMobile && <WSDataGrid
                        id="noteMainListGrid"
                        title="Notes"
                        columns={columns}
                        source={source}
                        addButton={{ label: 'New', color: 'secondary', }}
                        onAddButtonClick={handleClick}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    }
                    {isMobile &&
                        <WSMobileDataGridAdvanced title={'Notes'} addButton={add ? { label: "New", color: "secondary" } : undefined}
                            onAddButtonClick={handleClick} columns={mobColumns} id="noteMainListGrid" source={source} />
                    }
                </Grid>
                    : <PermissionDenied />
                }
            </Grid>
        </>
    )
})